import { useFeedback, useTranslation } from "@opendash/core";
import { Icon } from "@opendash/icons";
import { Button, Card, Popconfirm } from "antd";
import { observer } from "mobx-react-lite";
import Parse from "parse";
import * as React from "react";
import { useState } from "react";
import { Stop, Stop_Times } from "../js/parsegenerated";
import { StopUpdateModal } from "./StopUpdateModal";

export const StopCard = observer(
  (props: { stop: Stop; reloadStops: () => void }) => {
    const t = useTranslation();
    const { message } = useFeedback();
    const [updateModalVisible, setUpdateModalVisible] =
      useState<boolean>(false);

    async function deleteStop() {
      // Find the stop_times that should be deleted.
      const stoptimes = await new Parse.Query(Stop_Times)
        .equalTo("stop_id", {
          __type: "Pointer",
          className: Stop.className,
          objectId: props.stop.id,
        })
        .find();

      // Delete all collected objects
      for await (const stoptime of stoptimes) {
        await stoptime.destroy();
      }
      await props.stop.destroy();

      props.reloadStops();
    }

    return (
      <>
        <Card
          size="small"
          title={props.stop.get("stop_name")}
          extra={
            <>
              <Popconfirm
                title={t("gtfs:stop.detail.card.actions.delete.title")}
                onConfirm={deleteStop}
                onCancel={() => {}}
                okText={t("gtfs:global.button.confirm_label")}
                cancelText={t("gtfs:global.button.cancel_label")}
              >
                <Button
                  icon={<Icon color="red" icon="fa:trash" />}
                  shape="circle"
                  type="text"
                ></Button>
              </Popconfirm>
              <Button
                onClick={() => {
                  setUpdateModalVisible(true);
                }}
                icon={<Icon icon="fa:pen" />}
                shape="circle"
                type="text"
              ></Button>
            </>
          }
          // cover={
          //   <img
          //     alt="example"
          //     src={require("../../assets/maps_preview.png")}
          //   />
          // }
        >
          <p>{props.stop.get("stop_code")}</p>
          <p>{props.stop.get("stop_desc")}</p>
        </Card>

        <StopUpdateModal
          open={updateModalVisible}
          stop={props.stop}
          onOk={() => {
            setUpdateModalVisible(false);
            props.reloadStops();
            message.success(t("gtfs:global.message.savesuccess"));
          }}
          onCancel={() => {
            setUpdateModalVisible(false);
          }}
        />
      </>
    );
  }
);
